import { load, remove, save } from '@shared/helpers/localStorage';

const useLocalStorage = () => {
  return {
    load,
    save,
    remove,
  };
};

export default useLocalStorage;
